/* Avelia product page: full-width gallery with thumbnail hint, full-screen viewer with
   pinch + tap zoom, sticky add-to-cart bar, quantity, variants. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents, format) {
    var value = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return (format || '{{amount}}').replace(/\{\{\s*[a-z_]+\s*\}\}/, value);
  }

  /* ---------------- zoomable image (pinch, tap, drag) ---------------- */
  function Zoom(slide, img, onChange) {
    var s = 1, tx = 0, ty = 0;
    var pts = new Map();
    var start = null;          // gesture start state
    var tapCandidate = null;   // {x, y, t}
    var MAX = 4, TAP_SCALE = 2.5;

    function bounds(scale) {
      var w = img.offsetWidth * scale, h = img.offsetHeight * scale;
      return { x: Math.max(0, (w - slide.clientWidth) / 2), y: Math.max(0, (h - slide.clientHeight) / 2) };
    }
    function clamp() {
      var b = bounds(s);
      tx = Math.min(b.x, Math.max(-b.x, tx));
      ty = Math.min(b.y, Math.max(-b.y, ty));
    }
    function apply(animate) {
      img.style.transition = animate && !reduce ? 'transform .25s ease' : 'none';
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
      slide.classList.toggle('is-zoomed', s > 1.01);
      onChange(s > 1.01);
    }
    function local(e) {
      var r = slide.getBoundingClientRect();
      return { x: e.clientX - r.left - r.width / 2, y: e.clientY - r.top - r.height / 2 };
    }
    function zoomAt(p, ns, animate) {
      ns = Math.min(MAX, Math.max(1, ns));
      tx = p.x - (p.x - tx) * (ns / s);
      ty = p.y - (p.y - ty) * (ns / s);
      s = ns;
      if (s <= 1.01) { s = 1; tx = 0; ty = 0; }
      clamp(); apply(animate);
    }
    function reset(animate) { s = 1; tx = 0; ty = 0; apply(animate); }

    slide.addEventListener('pointerdown', function (e) {
      pts.set(e.pointerId, local(e));
      if (pts.size === 1) tapCandidate = { x: e.clientX, y: e.clientY, t: e.timeStamp };
      else tapCandidate = null;
      if (pts.size === 2) {
        var a = Array.from(pts.values());
        start = { d: Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y), m: { x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2 }, s: s, tx: tx, ty: ty };
      } else if (pts.size === 1 && s > 1.01) {
        start = { p: local(e), tx: tx, ty: ty };
      }
      if (s > 1.01 || pts.size === 2) slide.setPointerCapture(e.pointerId);
    });
    slide.addEventListener('pointermove', function (e) {
      if (!pts.has(e.pointerId)) return;
      pts.set(e.pointerId, local(e));
      if (tapCandidate && Math.hypot(e.clientX - tapCandidate.x, e.clientY - tapCandidate.y) > 8) tapCandidate = null;
      if (pts.size === 2 && start && start.d) {
        var a = Array.from(pts.values());
        var d = Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
        var m = { x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2 };
        var ns = Math.min(MAX, Math.max(1, start.s * d / start.d));
        tx = m.x - (start.m.x - start.tx) * (ns / start.s);
        ty = m.y - (start.m.y - start.ty) * (ns / start.s);
        s = ns; clamp(); apply(false);
      } else if (pts.size === 1 && start && start.p && s > 1.01) {
        var p = local(e);
        tx = start.tx + (p.x - start.p.x); ty = start.ty + (p.y - start.p.y);
        clamp(); apply(false);
      }
    });
    function end(e) {
      if (!pts.has(e.pointerId)) return;
      var wasTap = tapCandidate && pts.size === 1 && e.type === 'pointerup' && e.timeStamp - tapCandidate.t < 300;
      pts.delete(e.pointerId);
      if (pts.size === 1) {               // pinch -> pan with the remaining finger
        var rest = Array.from(pts.values())[0];
        start = { p: rest, tx: tx, ty: ty };
      } else if (pts.size === 0) {
        start = null;
        if (s < 1.05) reset(true);
      }
      if (wasTap) {
        tapCandidate = null;
        if (s > 1.01) reset(true); else zoomAt(local(e), TAP_SCALE, true);
      }
    }
    slide.addEventListener('pointerup', end);
    slide.addEventListener('pointercancel', end);
    // desktop: wheel / trackpad pinch
    slide.addEventListener('wheel', function (e) {
      if (!e.ctrlKey && s <= 1.01) return;
      e.preventDefault();
      zoomAt(local(e), s * Math.exp(-e.deltaY * 0.01), false);
    }, { passive: false });

    return { reset: reset, isZoomed: function () { return s > 1.01; } };
  }

  /* ---------------- full-screen viewer ---------------- */
  function initLightbox(dialog, sources) {
    var track = dialog.querySelector('[data-lb-track]');
    var count = dialog.querySelector('[data-lb-count]');
    var slides = [], zooms = [], active = 0, opener = null;

    function lock(on) {
      track.classList.toggle('is-locked', on);
      dialog.classList.toggle('is-zoomed', on);
    }
    sources.forEach(function (src, i) {
      var slide = document.createElement('div');
      slide.className = 'ap-lb__slide';
      var img = document.createElement('img');
      img.alt = 'Фото ' + (i + 1) + ' из ' + sources.length;
      img.decoding = 'async';
      img.draggable = false;
      img.dataset.src = src;
      slide.appendChild(img);
      track.appendChild(slide);
      slides.push(slide);
      zooms.push(Zoom(slide, img, lock));
    });

    function load(i) {
      [i - 1, i, i + 1].forEach(function (k) {
        var im = slides[k] && slides[k].querySelector('img');
        if (im && !im.src) im.src = im.dataset.src;
      });
    }
    function setActive(i) {
      active = i;
      count.textContent = (i + 1) + ' / ' + slides.length;
      load(i);
      dialog.querySelectorAll('[data-lb-step]').forEach(function (b) {
        b.disabled = b.dataset.lbStep < 0 ? i === 0 : i === slides.length - 1;
      });
    }
    function unzoomAll() { zooms.forEach(function (z) { z.reset(false); }); lock(false); }
    function go(i) {
      if (i < 0 || i >= slides.length) return;
      unzoomAll(); setActive(i);
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'instant' : 'smooth' });
    }

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== active) { unzoomAll(); setActive(i); }
      }, 80);
    }, { passive: true });

    dialog.querySelectorAll('[data-lb-step]').forEach(function (b) {
      b.addEventListener('click', function () { go(active + Number(b.dataset.lbStep)); });
    });
    dialog.querySelector('[data-lb-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); }
    });
    dialog.addEventListener('close', function () {
      unzoomAll();
      document.documentElement.classList.remove('ap-lb-open');
      if (opener) opener.focus({ preventScroll: true });
    });

    // swipe down closes (single finger, not zoomed)
    var sy = null, sx = 0, drag = false;
    track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || zooms[active].isZoomed()) { sy = null; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; drag = false;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (sy === null || e.touches.length !== 1) { sy = null; return; }
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (!drag) {
        if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx) * 1.2) drag = true;
        else { if (Math.abs(dx) > 12) sy = null; return; }
      }
      track.style.transition = 'none';
      track.style.transform = 'translateY(' + dy + 'px)';
      dialog.style.setProperty('--lb-fade', String(1 - Math.min(Math.abs(dy) / 500, 0.6)));
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (sy === null || !drag) { sy = null; return; }
      var dy = e.changedTouches[0].clientY - sy; sy = null; drag = false;
      track.style.transition = 'transform .2s ease';
      if (Math.abs(dy) > 90) dialog.close();
      track.style.transform = '';
      dialog.style.removeProperty('--lb-fade');
    });

    return function open(i, from) {
      opener = from || null;
      document.documentElement.classList.add('ap-lb-open');
      dialog.showModal();
      unzoomAll(); setActive(i);
      track.scrollLeft = i * track.clientWidth;
    };
  }

  /* ---------------- gallery ---------------- */
  function initGallery(root, lightbox) {
    var track = root.querySelector('[data-track]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('.ap-gal__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var thumbsTrack = root.querySelector('[data-thumbs-track]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (!slides.length) return;

    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'instant' : 'smooth' });
    }
    function update() {
      var i = current();
      thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
      if (thumbsTrack && thumbs[i]) {
        var b = thumbs[i];
        thumbsTrack.scrollTo({ left: b.offsetLeft - (thumbsTrack.clientWidth - b.offsetWidth) / 2, behavior: reduce ? 'instant' : 'smooth' });
      }
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    update();

    var openViewer = lightbox ? initLightbox(lightbox, slides.map(function (s) { return s.dataset.full; }).filter(Boolean)) : null;
    slides.forEach(function (s, i) {
      if (!s.dataset.full || !openViewer) return;
      s.addEventListener('click', function () { openViewer(i, s); });
      // two fingers on the gallery photo open the viewer straight away
      s.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) { e.preventDefault(); openViewer(i, s); }
      }, { passive: false });
    });

    root.apGoToMedia = function (mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) { go(i); return; }
      }
    };
  }

  /* ---------------- sticky add-to-cart bar (mobile, always on) ---------------- */
  function initBar() {
    var bar = document.querySelector('[data-ap-bar]');
    if (!bar) return;
    bar.hidden = false;
    bar.classList.add('is-visible');
    document.documentElement.classList.add('ap-has-bar');
  }

  /* ---------------- product ---------------- */
  function initProduct(section) {
    var dataEl = document.querySelector('[data-ap-product="' + section.getAttribute('data-section') + '"]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : null;
    var gallery = section.querySelector('[data-ap-gallery]');
    if (gallery) initGallery(gallery, document.querySelector('[data-lightbox]'));
    initBar();

    var qty = section.querySelector('.ap-qty__input');
    section.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
      });
    });

    if (!data) return;
    section.querySelectorAll('[data-opt]').forEach(function (r) {
      r.addEventListener('change', function () {
        var chosen = [];
        section.querySelectorAll('[data-opt]:checked').forEach(function (c) {
          chosen[parseInt(c.getAttribute('data-opt'), 10) - 1] = c.value;
        });
        var variant = data.variants.find(function (v) {
          return v.options.every(function (o, i) { return chosen[i] === undefined || chosen[i] === o; });
        });
        if (!variant) return;

        section.querySelector('[data-variant-input]').value = variant.id;
        var price = formatMoney(variant.price, data.moneyFormat);
        section.querySelector('[data-amount]').textContent = price;
        var barPrice = document.querySelector('[data-bar-price]');
        if (barPrice) barPrice.textContent = price;
        var cmp = section.querySelector('[data-compare]');
        cmp.innerHTML = variant.compare_at_price > variant.price
          ? '<s class="ap-muted">' + formatMoney(variant.compare_at_price, data.moneyFormat) + '</s> <span class="ap-pdp__badge">−' + Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%</span>'
          : '';
        var kaspi = section.querySelector('[data-kaspi]');
        if (kaspi) kaspi.textContent = formatMoney(Math.floor(variant.price / data.kaspiMonths), data.moneyFormat);

        document.querySelectorAll('[data-add], [data-mirror-submit]').forEach(function (btn) {
          btn.disabled = !variant.available;
          if (variant.available) btn.removeAttribute('aria-disabled'); else btn.setAttribute('aria-disabled', 'true');
          var label = btn.querySelector('span') || btn;
          label.textContent = variant.available ? data.addLabel : data.soldOut;
        });

        if (variant.featured_media && gallery && gallery.apGoToMedia) gallery.apGoToMedia(variant.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  function boot() { document.querySelectorAll('.ap-pdp[data-section]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
